/**
 * Put counter for fSelect facets in own <span> element.
 */
if( 'undefined' !== typeof FWP && 'undefined' !== typeof FWP.hooks ) {
	FWP.hooks.addFilter( 'facetwp/set_options/fselect', (opts, facet) => {
		opts.optionFormatter = (label, node) => {
			let counter = node.getAttribute( 'data-counter' );
			
			return counter ? `${label}<span class="facetwp-counter">(${counter})</span>` : label;
		};
		
		return opts;
	} );
}

/**
 * Add classes to parent when element reaches beginning or end of scroll area.
 * 
 * @param {HTMLElement} element
 * @param {HTMLElement} parent
 */
function scrollPositionEvent( element, parent ) {
	const { scrollTop, scrollHeight, clientHeight } = element;

	const atStart = scrollTop === 0;
	const atEnd = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

	parent.classList.toggle( 'at-start', atStart );
	parent.classList.toggle( 'at-end', atEnd );
	parent.classList.toggle( 'has-scroll', scrollHeight > clientHeight );
}

/**
 * Format HTML of fSelect facet.
 */
document.addEventListener( 'facetwp-loaded', () => {
	document.querySelectorAll( '.fs-dropdown' ).forEach( dropdownEl => {
		if( !dropdownEl.classList.contains( 'whippet-elements-added' ) ) {
			const optionsEl = dropdownEl.querySelector( '.fs-options' );

			if( optionsEl ) {
				optionsEl.addEventListener( 'scroll', event => scrollPositionEvent( event.target, dropdownEl ), { passive: true } );
				scrollPositionEvent( optionsEl, dropdownEl );

				const resizeObserver = new ResizeObserver( () => scrollPositionEvent( optionsEl, dropdownEl ) );
				resizeObserver.observe( optionsEl );

				dropdownEl.insertAdjacentHTML( 'afterend', '<div class="scroll">Scroll to see all results</div>' );

				dropdownEl.classList.add( 'whippet-elements-added' );
			}
		}
	} );
} );
